import React from "react";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Input from "../../../Components/Control/Input";
import moment from "jalali-moment";
import Separator from "../../../Components/Control/Separator";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Product from '../../../Server/Product';
import MyComponent from '../../../Components/MyComponent';

class ModalProductState extends MyComponent {
    constructor (props) {
        super(props);

        props.refer.current = this;

        this.state = {
            title: {
                DESTROY: 'امحا فرآورده',
                RETRIEVE: 'عودت فرآورده'
            },
            destroyedReasons: [
                {id: '', text: '...'},
                ...props.base.destroyedReasons.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            hospitalReturnReasons: [
                {id: '', text: '...'},
                ...props.base.hospitalReturnReasons.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            error: false,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            destroy: React.createRef(),
            retrieve: React.createRef(),
            close: React.createRef(),
            destroyedReasonId: React.createRef(),
            hospitalReturnReasonId: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    static validations = {
        destroyedReasonId: x => Boolean(x && x[0]?.id) || 'علت امحا انتخاب نشده',
        hospitalReturnReasonId: x => Boolean(x && x[0]?.id) || 'علت عودت انتخاب نشده'
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    componentDidMount () {

    }

    render () {
        const {state} = this;

        return <Modal ref={this.ref.modal}
                      name={'ModalProductState'}
                      size={'medium'}
                      error={state.error}
                      title={state.title[state.action]}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Input className={'pad-4 fb-10 fb-2x-20'} readOnly={true} label={'شماره فرآورده'} value={state.data?.productNumber}/>
                    <Input className={'pad-4 fb-10 fb-2x-20'} readOnly={true} label={'گروه خونی فرآورده'} direction={"ltr"} value={state.data?.productBloodGroupStr}/>
                    <Input className={'pad-4 fb-10 fb-2x-20'} readOnly={true} label={'نوع فرآورده'} value={state.data?.productTypeStr}/>
                    <Input className={'pad-4 fb-10 fb-2x-20'} readOnly={true} label={'تاریخ انقضا'} align={'center'} direction={'ltr'} value={state.data?.productExpireDate ? moment(state.data?.productExpireDate).format('jYYYY-jMM-jDD') : ''}/>
                    <Separator/>
                    {state.action === 'DESTROY' && <Select ref={this.ref.destroyedReasonId} value={state.fields?.destroyedReasonId} className={'pad-4 fb-20'} label={'علت امحا فرآورده'} options={state.destroyedReasons} validation={this.constructor.validations.destroyedReasonId} onChange={this.setField.bind(this, 'destroyedReasonId')}/>}
                    {state.action === 'RETRIEVE' && <Select ref={this.ref.hospitalReturnReasonId} value={state.fields?.hospitalReturnReasonId} className={'pad-4 fb-20'} label={'علت عودت فرآورده'} options={state.hospitalReturnReasons} validation={this.constructor.validations.hospitalReturnReasonId} onChange={this.setField.bind(this, 'hospitalReturnReasonId')}/>}
                    {state.action === 'DESTROY' && <p style={{color: 'var(--goo-red)', fontSize: 14}} className={'pad-4 fb-20'}>در صورت امحا، فرآورده از چرخه هموویژیلانس خارج شده و دیگر در سامانه قابل استفاده نخواهد بود.</p>}
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === 'DESTROY' && <Button refer={this.ref.destroy} className={'mar-4'} theme={'red'} onClick={this.destroyClickHandler.bind(this)}>امحا</Button>}
                {state.action === 'RETRIEVE' && <Button refer={this.ref.retrieve} className={'mar-4'} theme={'red'} onClick={this.retrieveClickHandler.bind(this)}>عودت</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    destroyClickHandler () {
        if (this.validate()) {
            this.ref.destroy.current.loading();
            this.setState({error: null});

            Product.destroy({
                productId: this.state.data?.productId,
                destroyedReasonId: this.state.fields?.destroyedReasonId[0]?.id
            }).then(_ => {
                new Notif('با موفقیت امحا شد.').show();

                this.ref.destroy.current.loading(false);

                this.close(true);
            }).catch(message => {
                this.ref.destroy.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    retrieveClickHandler () {
        if (this.validate()) {
            this.ref.retrieve.current.loading();
            this.setState({error: null});

            Product.retrieve({
                productId: this.state.data?.productId,
                hospitalReturnReasonId: this.state.fields?.hospitalReturnReasonId[0]?.id
            }).then(_ => {
                new Notif('با موفقیت عودت داده شد.').show();
                this.ref.retrieve.current.loading(false);
                this.close(true);
            }).catch(message => {
                this.ref.retrieve.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    open (data, action) {
        this.setState({
            data,
            action,
            error: null,
            fields: {}
        });

        this.ref.modal.current.open();
    }

    close (success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    validate () {
        let validate;

        if (this.state.action === 'DESTROY') {
            validate = Tool.validate(this.ref.destroyedReasonId);
        } else if (this.state.action === 'RETRIEVE') {
            validate = Tool.validate(this.ref.hospitalReturnReasonId);
        }

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalProductState);